module.exports = __webpack_public_path__ + "img/Gianfranco.33ae2ba6.jpg";